/**
 * PrimitiveDeployField — the registry DEFAULT picker.
 *
 * For any deploy-input field whose `source` the frontend hasn't been
 * taught (or that declares no `source` at all but is deploy-required),
 * we fall back to the SAME schema-driven primitive control SchemaForm
 * uses everywhere else (string / number / boolean / enum). This is what
 * keeps the deploy UI generic: a template can declare
 * `deployInput:{ required:true }` on a plain string field and get a
 * working text input with no new frontend code.
 *
 * Receives the uniform picker props bag (see deployInputSources.js).
 */

import React from 'react';
import { PrimitiveField } from '../SchemaForm';

export default function PrimitiveDeployField({
  name,
  schema,
  value,
  onChange,
  required,
  error,
  disabled,
}) {
  return (
    <PrimitiveField
      name={name}
      schema={schema}
      value={value}
      onChange={onChange}
      required={required}
      error={error}
      disabled={disabled}
    />
  );
}
